/**
 * TkPrefecturesPickコンポーネントは、日本の行政区域を選択するためのものです。
 * @param {ITkPrefecturesPickProps} props - コンポーネントのプロパティ。
 * @returns {React.FC<ITkPrefecturesPickProps>} - TkPrefecturesPickコンポーネント。
 */
import React, { useEffect, useMemo, useState } from "react";
import { ITkPrefecturesPickProps } from "../../../type/componentsType/TkPrefecturesPick";
import { Box } from "@mui/material";
import TkButton from "../../atoms/TkButton";
import PrefecturesPickModal from "./components/PrefecturesPickModal";
import { Prefectures } from "../../../assets/data/Constants";
import "./_style.scss";

const TkPrefecturesPick: React.FC<ITkPrefecturesPickProps> = (props) => {
  const { onSuccessful, wantToSetValue } = props;

  const [open, setOpen] = useState(false);
  const [showText, setShowText] = useState("");
  const [relShowText, setRelShowText] = useState("");

  const makeFieldValues = (data: any) => {
    const temShowText = data.map((item: any) => {
      return Object.keys(Prefectures).find(
        (key) => Prefectures[key as keyof typeof Prefectures] === item
      );
    });

    onSuccessful && onSuccessful(data);
    setShowText(temShowText.join("、"));
    setRelShowText(() => {
      if (temShowText.length > 3) {
        return temShowText.slice(0, 3).join("、") + "...";
      } else {
        return temShowText.join("、");
      }
    });
  };

  useEffect(() => {
    if (wantToSetValue) {
      makeFieldValues(wantToSetValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(wantToSetValue)]);

  const selectedData = useMemo(() => {
    if (showText === "") return [];
    return showText.split("、").map((item) => {
      return Prefectures[item as keyof typeof Prefectures];
    });
  }, [showText]);

  /**
   * 選択が成功した場合のコールバック関数を処理します。
   * @param {string[]} data - 選択された行政区域のデータ。
   */
  const handleSuccess = (data: string[]) => {
    makeFieldValues(data);
    setOpen(false);
  };

  return (
    <Box className="tkPrefecturesPick" data-testid="tkPrefecturesPick">
      <Box className="textBox">
        <Box className="text">都道府県：{relShowText}</Box>
        <TkButton onClick={() => setOpen(true)}>選択</TkButton>
      </Box>

      <PrefecturesPickModal
        onCancel={() => setOpen(false)}
        open={open}
        onSuccessful={handleSuccess}
        selectedPrefecture={selectedData}
      />
    </Box>
  );
};

export default TkPrefecturesPick;
